import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { doc, getDoc } from "firebase/firestore";
import "../style/Notifications.css"

function Notifications() {
    const [loading, setLoading] = useState(true);
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        const fetchNotifications = async () => {
        const user = auth.currentUser;
        if (!user) return;

        const userRef = doc(db, "Users", user.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
            const data = userSnap.data();
            const notifs = data.notifications || [];
            setNotifications(notifs.sort((a, b) => b.timestamp?.seconds - a.timestamp?.seconds));
        }

        setLoading(false);
        };

        fetchNotifications();
    }, []);

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div className="notif-wrapper">
        <h2 className="notif-title"> Notifications </h2>
        {notifications.length === 0 ? (
            <p className="notif-empty"> No notifications.</p>
        ) : (
            <ul className="notif-list">
            {notifications.map((n, i) => (
                <li key={i} 
                    className={`notif-item ${n.seen ? "seen" : "unseen"}`}>
                <div className="notification-message">
                    <strong>{n.message}</strong>
                    <small>{new Date(n.timestamp?.toDate?.()).toLocaleString()}</small>
                </div>
                </li>
            ))}
            </ul>
        )}
        </div>
    );
}

export default Notifications;
